module.exports = __webpack_public_path__ + "static/media/logoS.0e8f585c.png";